import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    color: 'red',
    border: '0.125rem solid rgba(255, 0, 0, 0.35)'
  }
}))

export default useStyles
